
import Select from 'react-select'
import React, { useState } from 'react'
import { AiOutlineDown } from 'react-icons/ai'
import Creatable from 'react-select/creatable'
import { Drawer, Dropdown, Menu, Tabs } from 'antd'

import { usePet, useToggle, getInputProps } from '../../modules'
import { buildFormFieldPayload } from '../../formDataSources'

import Confirm from '../reusable/confirm'

import FormFields from './formFields'
import TemplateEditor from '../modals/templateEditor'

const { TabPane } = Tabs

const EditInputForm = ({ form, toggle, visible, categories, onPerform }) => {
    const [name, setName] = useState(form?.name)
    const [index, setIndex] = useState()
    const [border, setBorder] = useState(form?.template?.border)
    const [format, setFormat] = useState({ label: form?.template?.format, value: form?.template?.format })
    const [fields, setFields] = useState((form?.fields ?? []).map(getInputProps))
    const [selected, setSelected] = useState()
    const [category, setCategory] = useState({ label: form?.category, value: form?.category })
    const [cats, setCats] = useState([...categories])
    const [orientation, setOrientation] = useState({ label: form?.template?.orientation, value: form?.template?.orientation })
    
    const [field, toggleField] = useToggle()
    const [editor, toggleEditor] = useToggle()

    let formats = ['A4', 'A3', 'A2', 'Legal', 'Letter', 'Tabloid']
    let orientations = ['Portrait', 'Landscape']

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Input form has been created', ops('success'))

        setTimeout(close, 300)
    }

    const editField = i => {
        setSelected(fields[i])
        setIndex(i)
        toggleField()
    }

    const [{ loading }, execute] = usePet('editInputForm', {
        id: form?._id,
        name,
        category: category?.value,
        saleItems: [],
        fields: fields.map(buildFormFieldPayload),
        format: format?.value,
        orientation: orientation?.value,
        border
    }, { notify: true, hasFile: true, callback: onComplete, manual: true })

    const onSave = ({ field, i }) => {
        setFields(val => {
            if (i >= 0)
                val[i] = field
            else
                val = [...val, field]

            return val
        })
    }

    const clearSelected = () => {
        setSelected()
        setIndex()
    }

    const remove = index => {
        clearSelected()
        setFields(val => val.filter((_, i) => i !== index))
    }

    const newField = () => {
        clearSelected()
        toggleField()
    }

    const editorDidMount = () => {
        console.log('editorDidMount')
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ toggleEditor } className="text-white hisani-btn-orange-light mr-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Edit Printout</button>
                    <button disabled={loading} onClick={() => Confirm({
                        title: 'Edit Input Form',
                        message: 'Are you sure you want to save these changes?',
                        onOk: execute,
                        okText: 'Proceed',
                    })} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">Edit Input Form</p>
            <Tabs>
                <TabPane key="0" tab="Details">
                    <div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full px-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Form Name
                                </label>
                                <input
                                    onChange={e => setName(e.target.value)}
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-role-name"
                                    type="text"
                                    value={name}
                                    name="name"
                                    placeholder="Daily Visits" />
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full px-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Form Category
                                </label>
                                <Creatable
                                    value={category}
                                    onCreateOption={val => {
                                        setCats([...cats, val])
                                        setCategory({ label: val, value: val })
                                    }}
                                    onChange={setCategory}
                                    options={cats.map(cat => ({ label: cat, value: cat }))}
                                    placeholder="Select Category" />
                            </div>
                        </div>
                    </div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mt-3" htmlFor="grid-name">Fields</label>
                    <div className="flex items-center justify-between">
                        {
                            fields?.length > 0 ?
                                <>
                                    <table className="table-auto w-full">
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Type</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                fields.map((fld, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{fld.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{fld.type?.label}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div>
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            <Menu.Item onClick={() => editField(key)}>View</Menu.Item>
                                                                            <Menu.Item onClick={() => remove(key)}>Remove</Menu.Item>
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </>
                                :
                                // <div className="w-full h-12 text-center">
                                <p className="font-semibold w-full text-center mt-4">Please click below to add new fields</p>
                            // </div>
                        }
                    </div>
                    <div className="w-full h-16 text-center">
                        <button onClick={newField} className="btn py-2 px-3 mt-0 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Field</button>
                    </div>
                </TabPane>
                <TabPane key="1" tab="Printout">
                    <div className="rounded border border-blue-200 bg-blue-50 px-4 py-3 mb-4 text-sm text-blue-900">
                        This printout is optional for structured capture. You can keep using the default layout, or customise the printout here whenever the hospital is ready.
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Format
                            </label>
                            <Select
                                value={format}
                                onChange={setFormat}
                                options={formats.map(fm => ({ label: fm, value: fm }))}
                                placeholder="Select Format" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Orientation
                            </label>
                            <Select
                                value={orientation}
                                onChange={setOrientation}
                                options={orientations.map(or => ({ label: or, value: or }))}
                                placeholder="Select Orientation" />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Border
                            </label>
                            <input
                                onChange={e => setBorder(e.target.value)}
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-border"
                                type="number"
                                value={border}
                                name="border"
                                placeholder="Border Width in mm" />
                        </div>
                    </div>
                </TabPane>
                <TabPane key="2" tab="Preview">
                    <div>
                        <p>Print Template Preview</p>
                    </div>
                </TabPane>
            </Tabs>
            <TemplateEditor
                id={ form?.template?._id }
                visible={ editor }
                toggle={ toggleEditor } />
            {
                field &&
                <FormFields
                    index={index}
                    onSave={onSave}
                    visible={field}
                    field={selected}
                    toggle={toggleField} />
            }
        </Drawer>
    )
}

export default EditInputForm
